export default {"src":"/_next/static/media/mail-outline.6ad2d5d9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};